// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Filter24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Filter24: FC<Filter24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M13 9V7h3V3h2v4h3v2h-8Zm3 12V11h2v10h-2ZM6 21v-4H3v-2h8v2H8v4H6Zm0-8V3h2v10H6Z" />
        </svg>
    );
};

export default Filter24;
